var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tooltip',{attrs:{"placement":"right"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("現在の文字数と推奨文字数です。")]),_vm._v(" "),_c('span',[_vm._v("文字数："+_vm._s(_vm.textLength)+"/"+_vm._s(_vm.lengthChecklength))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }